import { render } from "./PopupBox.vue?vue&type=template&id=802bf768"
import script from "./PopupBox.vue?vue&type=script&lang=js"
export * from "./PopupBox.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eemas/aims2go/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__